import React, { useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { VariableCategory } from './VariableCategory';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { Form } from '../../../../components/general/general-component/abstruct-component/AbstructForm';
import { postCategory } from '../../../../store/Actions/ActionCategory';

function AddCategory({ setIsAdded,open, setOpen }) {

  const { mode, dispatch,navigate,langLocal } = AbstructVar();

  const { translate } = AbstructLang();
  
  const { state, setStateCustom, setLoad } = VariableCategory();

  const handleSubmit = (e) => {
    e.preventDefault();
    //setIsAdded(true)
    dispatch(postCategory(state, setLoad));
  };

  const formFields = [
    { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
    { name: 'description', label: 'description', type: 'text', inputType: 'text', iconType: "pencil" },
  ];

  return (
    <RModal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      center
      classNames={{
        modal: 'popupR',
      }}
      focusTrapped={false}
      overlayOpacity={0.5}
    >
      <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
        <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
          <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('add_category')}</p>
        </div>
        <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} buttonLabel="add" />
      </div>
    </RModal>
  );
}

export default AddCategory;